import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const REMDOCS_ACOMPTES_CLIENTS_SCHEMA_LITERAL = {
    title: 'Schéma Acomptes Clients',
    description: 'Acomptes Clients',
    version: 1,
    keyCompression: false,
    primaryKey: 'PK_ID',
    type: 'object',
    properties: {
      PK_ID : { type : 'string', maxLength : 100 },
      MD_CAISSE_SESSION : { type : 'string' },
      DOMAINE : { type : 'number' },
      VENTES : { type : 'string' },
      ACHATS : { type : 'string' },
      CT_NUM : { type : 'string' },
      CT_INTITULE : { type : 'string' },
    },
    required: [ ]
} as const;

const schemaTyped = toTypedRxJsonSchema(REMDOCS_ACOMPTES_CLIENTS_SCHEMA_LITERAL);
export type RxRemdocsAcomptesClientsDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const REMDOCS_ACOMPTES_CLIENTS_SCHEMA: RxJsonSchema<RxRemdocsAcomptesClientsDocumentType> = REMDOCS_ACOMPTES_CLIENTS_SCHEMA_LITERAL;
